// Halloween-Glücksrad (sections/halloween-wheel.liquid). Zeichnet das Rad als SVG, wählt den
// Gewinn nach Gewichtung, dreht dorthin und zeigt Code + Einlösen. Ansicht nach Datum
// (deutsche Zeit): vor dem Start, Rad, vorbei. Vorschau: ?gluecksrad=an / ?gluecksrad=aus.
(function () {
  var SVG = 'http://www.w3.org/2000/svg';
  var COLORS = [
    { bg: '#f27b20', fg: '#1b1026' },
    { bg: '#5b2a86', fg: '#f4f0e6' },
    { bg: '#1b1026', fg: '#f27b20' }
  ];
  var SOUR = { bg: '#8bc34a', fg: '#1b1026' };
  var ICONS = {
    percent: '<circle cx="-6" cy="-6" r="3.6"/><circle cx="6" cy="6" r="3.6"/><path d="M8-9L-8 9" stroke-width="3" stroke="currentColor"/>',
    truck: '<path d="M-11-6h13v11h-13zM2-2h5l4 4v3H2z"/><circle cx="-6" cy="7" r="2.6"/><circle cx="6" cy="7" r="2.6"/>',
    gift: '<path d="M-10-3h20v5h-20zM-8 2h16v9h-16z"/><path d="M-1.5-3h3v14h-3z" fill-opacity=".35"/><path d="M0-3c-3-7-9-6-7-2 1 2 7 2 7 2s6 0 7-2c2-4-4-5-7 2z"/>',
    candy: '<circle r="6"/><path d="M-6 0l-7-6v12zM6 0l7-6v12z"/>',
    clover:
      '<circle cx="0" cy="-6" r="4.6"/><circle cx="6" cy="0" r="4.6"/><circle cx="0" cy="6" r="4.6"/><circle cx="-6" cy="0" r="4.6"/>' +
      '<path d="M1 3q3 6 8 9" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>',
    cat:
      '<path d="M-8 12c-2-6-1-12 2-15l-1-6 5 4h4l5-4-1 6c3 3 4 9 2 15z"/>' +
      '<path d="M8 11q7-1 5-8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '<ellipse cx="-3" cy="-2" rx="1.4" ry="2" fill="#1b1026"/><ellipse cx="3" cy="-2" rx="1.4" ry="2" fill="#1b1026"/>',
    ghost: '<path d="M-8 10V-2a8 8 0 0116 0v12l-4-3-4 3-4-3z"/><circle cx="-3" cy="-2" r="1.6" fill="#8bc34a"/><circle cx="3" cy="-2" r="1.6" fill="#8bc34a"/>'
  };

  function init(root) {
    var prizes = [];
    try {
      prizes = JSON.parse(root.querySelector('[data-hw-prizes]').textContent) || [];
    } catch (e) {}
    var d = root.dataset;
    var sourOn = d.sour === 'true' && Number(d.sourWeight) > 0;
    var respin = d.respin === 'true';
    var storageKey = d.storageKey;

    showView(root, phase(d));
    if (!prizes.length) return;

    // Felder: alle Gewinne zweimal, dazwischen je ein Saures-Feld.
    var segments = [];
    for (var round = 0; round < 2; round++) {
      prizes.forEach(function (p, i) {
        segments.push({ prize: i, color: COLORS[i % COLORS.length], icon: p.icon });
      });
      if (sourOn) segments.push({ prize: -1, color: SOUR, icon: 'ghost' });
    }

    var wheel = root.querySelector('[data-hw-wheel]');
    wheel.appendChild(drawWheel(segments));
    var spinButton = root.querySelector('[data-hw-spin]');
    var rotation = 0;
    var spinning = false;

    var stored = null;
    if (!respin) {
      try {
        stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
      } catch (e) {}
    }
    if (stored && prizes[stored.prize] && phase(d) === 'active') showResult(stored.prize, false);

    spinButton.addEventListener('click', function () {
      if (spinning) return;
      spinning = true;
      spinButton.disabled = true;
      var won = draw(prizes, sourOn ? Number(d.sourWeight) : 0);
      var matches = [];
      segments.forEach(function (s, i) {
        if (s.prize === won) matches.push(i);
      });
      var index = matches[(Math.random() * matches.length) | 0];
      var seg = 360 / segments.length;
      var center = (index + 0.5) * seg + (Math.random() - 0.5) * seg * 0.6;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = 360 - center;
      var delta = (((target - rotation) % 360) + 360) % 360;
      rotation += delta + (reduced ? 360 : 360 * 6);
      wheel.style.transitionDuration = reduced ? '0.8s' : '5.2s';
      wheel.style.transform = 'rotate(' + rotation + 'deg)';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        spinning = false;
        spinButton.disabled = false;
        if (won >= 0 && !respin) {
          try {
            localStorage.setItem(storageKey, JSON.stringify({ prize: won }));
          } catch (e) {}
        }
        showResult(won, true);
      }
      wheel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, reduced ? 1200 : 5800);
    });

    var result = root.querySelector('[data-hw-view="result"]');
    var redeem = result.querySelector('[data-hw-redeem]');
    var again = result.querySelector('[data-hw-again]');
    var variantWrap = result.querySelector('[data-hw-variant-wrap]');
    var variantSelect = result.querySelector('[data-hw-variant]');
    var error = result.querySelector('[data-hw-error]');
    var current = null;

    function showResult(index, animate) {
      var sour = index < 0;
      current = sour ? null : prizes[index];
      result.querySelector('[data-hw-result-eyebrow]').textContent = sour ? '' : d.winEyebrow;
      result.querySelector('[data-hw-result-title]').textContent = sour ? d.sourTitle : current.title;
      var text = sour ? d.sourText : current.text;
      var textEl = result.querySelector('[data-hw-result-text]');
      textEl.textContent = text || '';
      textEl.hidden = !text;
      result.querySelector('[data-hw-result-fine]').innerHTML = sour ? '' : current.fine || '';
      result.querySelector('[data-hw-code-wrap]').hidden = sour || !current.code;
      result.querySelector('[data-hw-code]').textContent = sour ? '' : current.code;
      result.querySelector('[data-hw-copy-hint]').textContent = 'Kopieren';
      error.hidden = true;

      var variants = (!sour && current.variants) || [];
      variantSelect.innerHTML = '';
      variants.forEach(function (v) {
        var option = document.createElement('option');
        option.value = v.id;
        option.textContent = v.title;
        variantSelect.appendChild(option);
      });
      variantWrap.hidden = variants.length < 2;
      redeem.hidden = sour || !current.code;
      if (!sour) redeem.href = discountUrl(current.code, current.redirect);
      again.hidden = !(respin || sour);
      result.classList.toggle('hw__result--sour', sour);

      showView(root, 'result');
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: animate ? 'smooth' : 'auto', block: 'center' });
      if (animate && !sour) confetti();
    }

    redeem.addEventListener('click', function (event) {
      if (!current || !current.variants || !current.variants.length) return;
      // Gratis-Produkt: erst in den Warenkorb, dann Code aktivieren und zum Warenkorb.
      event.preventDefault();
      var id = variantSelect.value || current.variants[0].id;
      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      redeem.setAttribute('aria-busy', 'true');
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          location.href = discountUrl(current.code, cartRoot + 'cart');
        })
        .catch(function () {
          redeem.removeAttribute('aria-busy');
          error.hidden = false;
        });
    });

    again.addEventListener('click', function () {
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}
      showView(root, 'active');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var copy = result.querySelector('[data-hw-copy]');
    copy.addEventListener('click', function () {
      if (!current) return;
      copyText(current.code).then(function () {
        result.querySelector('[data-hw-copy-hint]').textContent = 'Kopiert ✓';
      });
    });
  }

  function phase(d) {
    if (d.editorView) return d.editorView;
    var forced = '';
    try {
      var param = new URLSearchParams(location.search).get('gluecksrad');
      if (param === 'aus') sessionStorage.removeItem('pny-hw-preview');
      else if (param === 'an') sessionStorage.setItem('pny-hw-preview', 'an');
      forced = sessionStorage.getItem('pny-hw-preview') || '';
    } catch (e) {}
    if (forced) return 'active';
    var today;
    try {
      today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(new Date());
    } catch (e) {
      today = new Date().toISOString().slice(0, 10);
    }
    var iso = /^\d{4}-\d{2}-\d{2}$/;
    if (iso.test(d.start) && today < d.start) return 'before';
    if (iso.test(d.end) && today > d.end) return 'after';
    return 'active';
  }

  function showView(root, name) {
    root.querySelectorAll('[data-hw-view]').forEach(function (view) {
      view.hidden = view.dataset.hwView !== name;
    });
  }

  // Saures mit festem Anteil, sonst Gewinn nach Gewichtung (alle 0 = gleich oft).
  function draw(prizes, sourPercent) {
    if (sourPercent > 0 && Math.random() * 100 < sourPercent) return -1;
    var total = prizes.reduce(function (sum, p) {
      return sum + Math.max(0, Number(p.weight) || 0);
    }, 0);
    if (!total) return (Math.random() * prizes.length) | 0;
    var r = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) {
      r -= Math.max(0, Number(prizes[i].weight) || 0);
      if (r < 0) return i;
    }
    return prizes.length - 1;
  }

  function drawWheel(segments) {
    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('viewBox', '-100 -100 200 200');
    svg.setAttribute('aria-hidden', 'true');
    var seg = 360 / segments.length;
    var r = 96;
    var html = '<circle r="99" fill="#f4f0e6"/>';
    segments.forEach(function (s, i) {
      var a0 = rad(i * seg);
      var a1 = rad((i + 1) * seg);
      var large = seg > 180 ? 1 : 0;
      html +=
        '<path d="M0 0L' + pt(a0, r) + 'A' + r + ' ' + r + ' 0 ' + large + ' 1 ' + pt(a1, r) + 'Z" fill="' + s.color.bg + '"/>';
      html +=
        '<g transform="rotate(' + (i + 0.5) * seg + ')" fill="' + s.color.fg + '" color="' + s.color.fg + '">' +
        // Nur Symbole – was man gewonnen hat, steht erst in der Gewinn-Ansicht.
        '<g transform="translate(0 -62) scale(1.7)">' + (ICONS[s.icon] || ICONS.candy) + '</g></g>';
    });
    html += '<circle r="96" fill="none" stroke="#1b1026" stroke-width="2"/>';
    for (var i = 0; i < segments.length; i++) {
      html += '<circle cx="' + pt(rad(i * seg), 92).split(' ').join('" cy="') + '" r="2" fill="#f4f0e6"/>';
    }
    svg.innerHTML = html;
    return svg;
  }

  function rad(deg) {
    return (deg * Math.PI) / 180;
  }
  function pt(a, r) {
    return (Math.sin(a) * r).toFixed(2) + ' ' + (-Math.cos(a) * r).toFixed(2);
  }

  function discountUrl(code, redirect) {
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var target = redirect || cartRoot + 'collections/all';
    return cartRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    var area = document.createElement('textarea');
    area.value = text;
    area.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    area.remove();
    return Promise.resolve();
  }

  // Bonbon-Konfetti in Halloween-Farben.
  function confetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#f27b20', '#5b2a86', '#8bc34a', '#f4f0e6', '#ffb347'];
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = (canvas.width = window.innerWidth * dpr);
    var h = (canvas.height = window.innerHeight * dpr);
    var pieces = [];
    for (var i = 0; i < 140; i++) {
      pieces.push({
        x: w * (0.2 + Math.random() * 0.6),
        y: h * 0.6,
        vx: (Math.random() - 0.5) * 16 * dpr,
        vy: -(8 + Math.random() * 9) * dpr,
        size: (6 + Math.random() * 6) * dpr,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: colors[(Math.random() * colors.length) | 0],
        round: Math.random() < 0.4
      });
    }
    var start = performance.now();
    function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, w, h);
      ctx.globalAlpha = t > 2700 ? Math.max(0, (3500 - t) / 800) : 1;
      pieces.forEach(function (p) {
        p.vy += 0.12 * dpr;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2.5, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        }
        ctx.restore();
      });
      if (t < 3500) requestAnimationFrame(frame);
      else canvas.remove();
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    document.querySelectorAll('[data-hw]').forEach(function (root) {
      if (root.dataset.hwReady) return;
      root.dataset.hwReady = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
